import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_cancel_sales_order_lines_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { order_id: number, order_line_numbers: number[], reason_code_id: number, reason_notes?: string }): Promise<{ errors?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil($inParams.order_line_numbers)) {
      $missingRequiredInParams.push('\'order_line_numbers\'');
    }
    if (isNil($inParams.reason_code_id)) {
      $missingRequiredInParams.push('\'reason_code_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

